/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import Types from '../constants/actionTypes';

export const openModal =
  (type, props, id, tab = '') =>
  (dispatch) => {
    document.querySelector('body').style.overflow = 'hidden';
    dispatch({
      type: Types.OPEN_MODAL,
      props,
      modalType: type,
      id,
      tab
    });
  };

export const updateModal = (id, tab) => (dispatch) =>
  dispatch({
    type: Types.UPDATE_MODAL,
    id,
    tab
  });

export const closeModal = (type, id) => (dispatch) => {
  document.querySelector('body').style.overflow = 'scroll';
  dispatch({ type: Types.CLOSE_MODAL, id });
};

export const closeAllModals = () => (dispatch) => {
  dispatch({ type: Types.CLOSE_ALL_MODALS });
};
